var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"rgb(250, 209, 178)","d":"M70.442,51.001 L5.558,51.001 C2.488,51.001 0.000,48.511 0.000,45.443 L0.000,45.433 C0.000,42.363 2.488,39.875 5.558,39.875 L70.442,39.875 C73.512,39.875 76.000,42.363 76.000,45.433 L76.000,45.443 C76.000,48.511 73.512,51.001 70.442,51.001 ZM70.453,30.718 L5.547,30.718 C2.483,30.718 0.000,28.236 0.000,25.172 C0.000,22.109 2.483,19.625 5.547,19.625 L70.453,19.625 C73.517,19.625 76.000,22.109 76.000,25.172 C76.000,28.236 73.517,30.718 70.453,30.718 ZM70.442,11.125 L5.558,11.125 C2.488,11.125 0.000,8.637 0.000,5.567 L0.000,5.558 C0.000,2.489 2.488,0.000 5.558,0.000 L70.442,0.000 C73.512,0.000 76.000,2.489 76.000,5.558 L76.000,5.567 C76.000,8.637 73.512,11.125 70.442,11.125 Z"}));
}

Burger.defaultProps = {"width":"76px","height":"51px"};

module.exports = Burger;

Burger.default = Burger;
